<template>
    <Dialog v-model:open="isOpen">
        <DialogContent id="login-modal">
            <template v-if="step == 'choose'">
                <DialogHeader>
                    <DialogTitle>{{ props.title }}</DialogTitle>
                </DialogHeader>
                <h2>{{ $t("SignIn.WouldYouLikeToLogin") }}</h2>
                <p class="text-base">
                    {{ $t("SignIn.LoginForAdvancedFeatures") }}
                </p>
                <div class="flex justify-center gap-4">
                    <Button @click="continueAsGuest">
                        {{ $t("SignIn.ContinueAsGuest") }}
                    </Button>
                    <Button variant="primary" fill="solid" @click="startLogin">
                        {{ $t("Global.SignInLabel") }}
                    </Button>
                </div>
            </template>
            <template v-else-if="step == 'login'">
                <DialogHeader>
                    <DialogTitle>{{ $t("Global.SignInLabel") }}</DialogTitle>
                </DialogHeader>
                <LoginForm @success="continueLogin" @complete="completeLogin" />
            </template>
        </DialogContent>
    </Dialog>
</template>
<script setup lang="ts">
const { gtag } = useGtag();
const guestCookie = useGuestCookie();

const props = defineProps<{ title: string }>();
const emit = defineEmits<{ continue: [isAuthenticated: boolean]; complete: [response: LogInResponse] }>();

const isOpen = ref(false);
const step = ref<"choose" | "login">("choose");

function continueAsGuest() {
    guestCookie.value = true;
    emit("continue", false);
    gtag("event", "sign_in_modal_continue_as_guest");
    isOpen.value = false;
}

function startLogin() {
    gtag("event", "sign_in_modal_sign_in");
    step.value = "login";
}

async function continueLogin() {
    emit("continue", true);
}

async function completeLogin(response: LogInResponse) {
    emit("complete", response);
    isOpen.value = false;
}

function openDialog() {
    step.value = "choose";
    isOpen.value = true;
    gtag("event", "sign_in_modal_open");
}

defineExpose({ openDialog });
</script>
